import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../../generic/FieldProps';
import { GenericInputField } from '../../../../../generic/GenericInputField';
import { BirthRegistrationNumberInput } from './BirthRegistrationNumberInput';

export function BirthRegistrationNumberField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues>
      {...props}
      Input={BirthRegistrationNumberInput}
      label='Vorname'
    />
  );
}
